import React from "react";
import { motion, cubicBezier } from "framer-motion";

//Data
import { menuData } from "../data/menuData";

//Default transitioncategories
const easing = cubicBezier(0.6, 0.01, -0.05, 0.9);
const transition = { duration: 0.8, ease: easing };

const menu = (props) => {
  const { setActiveObject, workingHours, getClass } = props;
  const showItem = (item) => item.isBaseVariant !== false;
  const offer = menuData.filter(
    (item) => item.category === "offer" && showItem(item),
  );
  const breakfast = menuData.filter(
    (item) => item.category === "breakfast" && showItem(item),
  );
  const chicken = menuData.filter(
    (item) => item.category === "chicken" && showItem(item),
  );
  const pork = menuData.filter(
    (item) => item.category === "pork" && showItem(item),
  );
  const burger = menuData.filter(
    (item) => item.category === "burger" && showItem(item),
  );
  const beef = menuData.filter(
    (item) => item.category === "beef" && showItem(item),
  );
  const barbecue = menuData.filter(
    (item) => item.category === "barbecue" && showItem(item),
  );
  const sausage = menuData.filter(
    (item) => item.category === "sausage" && showItem(item),
  );
  const vegan = menuData.filter(
    (item) => item.category === "vegan" && showItem(item),
  );
  const salad = menuData.filter(
    (item) => item.category === "salad" && showItem(item),
  );
  const sides = menuData.filter(
    (item) => item.category === "sides" && showItem(item),
  );
  const desert = menuData.filter(
    (item) => item.category === "desert" && showItem(item),
  );
  const drinks = menuData.filter(
    (item) => item.category === "drinks" && showItem(item),
  );
  const pizza = menuData.filter(
    (item) => item.category === "pizza" && showItem(item),
  );

  const isBeforeNoon = new Date().getHours() < 12;
  //const pizzaTime = new Date().getHours() * 60 + new Date().getMinutes() >= 12 * 60 && new Date().getHours() * 60 + new Date().getMinutes() <= 22 * 60 + 30;
  const pizzaTime = new Date().getHours() >= 16;

  return (
    <>
      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Акција</span>
      </motion.h4>
      <ul className="list-menu offer">
        {offer.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img
              className="list-img"
              src={product.image || "https://idzuo.com/menuImages/Placeholder.png"}
              alt="Ресторан идзуо"
            />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}{product.isNew && <span className="badge-new">novo</span>}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>

      {isBeforeNoon && (
        <>
          <motion.h4
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            className="menu-title"
          >
            <span>Доручак</span>
          </motion.h4>
          <ul className="list-menu">
            {breakfast.map((product) => (
              <motion.li
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 2.4, ...transition }}
                key={product.id}
                onClick={() => {
                  setActiveObject(product);
                  workingHours();
                }}
                className={getClass(product.id)}
              >
                <img
                  className="list-img"
                  src={product.image || "https://idzuo.com/menuImages/Placeholder.png"}
                  alt="Ресторан идзуо"
                />
                <span className="list-menu-info">
                  <span className="list-menu-top">
                    <span className="list-title">{product.name}{product.isNew && <span className="badge-new">novo</span>}</span>
                    <span className="list-desc">{product.desc}</span>
                  </span>
                  <span className="list-price">{product.price} рсд</span>
                </span>
              </motion.li>
            ))}
          </ul>
        </>
      )}

      {pizzaTime && (
        <>
          <motion.h4
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            className="menu-title"
          >
            <span>Пица 30цм</span>
          </motion.h4>
          <ul className="list-menu">
            {pizza.map((product) => (
              <motion.li
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 2.4, ...transition }}
                key={product.id}
                onClick={() => {
                  setActiveObject(product);
                  workingHours();
                }}
                className={getClass(product.id)}
              >
                <img
                  className="list-img"
                  src={product.image || "https://idzuo.com/menuImages/Placeholder.png"}
                  alt="Ресторан идзуо"
                />
                <span className="list-menu-info">
                  <span className="list-menu-top">
                    <span className="list-title">{product.name}{product.isNew && <span className="badge-new">novo</span>}</span>
                    <span className="list-desc">{product.desc}</span>
                  </span>
                  <span className="list-price">{product.price} рсд</span>
                </span>
              </motion.li>
            ))}
          </ul>
        </>
      )}

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Пилетина</span>
      </motion.h4>
      <ul className="list-menu">
        {chicken.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img
              className="list-img"
              src={product.image || "https://idzuo.com/menuImages/Placeholder.png"}
              alt="Ресторан идзуо"
            />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}{product.isNew && <span className="badge-new">novo</span>}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Свињетина</span>
      </motion.h4>
      <ul className="list-menu">
        {pork.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img
              className="list-img"
              src={product.image || "https://idzuo.com/menuImages/Placeholder.png"}
              alt="Ресторан идзуо"
            />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}{product.isNew && <span className="badge-new">novo</span>}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Бургери</span>
      </motion.h4>
      <ul className="list-menu">
        {burger.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img
              className="list-img"
              src={product.image || "https://idzuo.com/menuImages/Placeholder.png"}
              alt="Ресторан идзуо"
            />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}{product.isNew && <span className="badge-new">novo</span>}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Јунетина</span>
      </motion.h4>
      <ul className="list-menu">
        {beef.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img
              className="list-img"
              src={product.image || "https://idzuo.com/menuImages/Placeholder.png"}
              alt="Ресторан идзуо"
            />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}{product.isNew && <span className="badge-new">novo</span>}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Јела на роштиљу</span>
      </motion.h4>
      <ul className="list-menu">
        {barbecue.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id) + " barbecue"}
          >
            <img
              className="list-img"
              src={product.image || "https://idzuo.com/menuImages/Placeholder.png"}
              alt="Ресторан идзуо"
            />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}{product.isNew && <span className="badge-new">novo</span>}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Кобасице</span>
      </motion.h4>
      <ul className="list-menu">
        {sausage.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img
              className="list-img"
              src={product.image || "https://idzuo.com/menuImages/Placeholder.png"}
              alt="Ресторан идзуо"
            />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}{product.isNew && <span className="badge-new">novo</span>}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Посна јела</span>
      </motion.h4>
      <ul className="list-menu">
        {vegan.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img
              className="list-img"
              src={product.image || "https://idzuo.com/menuImages/Placeholder.png"}
              alt="Ресторан идзуо"
            />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}{product.isNew && <span className="badge-new">novo</span>}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Салате</span>
      </motion.h4>
      <ul className="list-menu">
        {salad.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img
              className="list-img"
              src={product.image || "https://idzuo.com/menuImages/Placeholder.png"}
              alt="Ресторан идзуо"
            />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}{product.isNew && <span className="badge-new">novo</span>}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Прилози</span>
      </motion.h4>
      <ul className="list-menu">
        {sides.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img
              className="list-img"
              src={product.image || "https://idzuo.com/menuImages/Placeholder.png"}
              alt="Ресторан идзуо"
            />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}{product.isNew && <span className="badge-new">novo</span>}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Десерт</span>
      </motion.h4>
      <ul className="list-menu">
        {desert.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img
              className="list-img"
              src={product.image || "https://idzuo.com/menuImages/Placeholder.png"}
              alt="Ресторан идзуо"
            />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}{product.isNew && <span className="badge-new">novo</span>}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Пиће</span>
      </motion.h4>
      <ul className="list-menu">
        {drinks.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img
              className="list-img"
              src={product.image || "https://idzuo.com/menuImages/Placeholder.png"}
              alt="Ресторан идзуо"
            />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}{product.isNew && <span className="badge-new">novo</span>}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>
    </>
  );
};

export default menu;
